import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import de from "./locales/de.json";

export const defaultNS = "its4plan";
export const resources = {
  de: {
    its4plan: de,
  },
} as const;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "de",
    fallbackLng: "de",
    ns: ["its4plan"],
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(console.error);

export default i18n;
